import renderHeaderDropdown from "../../components/HeaderDropDownHOC";

import VerticalList from "../VerticalList";




const VerticalListDropdown = renderHeaderDropdown(
    "Industries",
    VerticalList
);

export default VerticalListDropdown;